import { withInstallFunction } from '@jdesign-vue/utils'

import Notify from './src/notify'

export const JdNotification = withInstallFunction(Notify, '$notify')
export default JdNotification

export * from './src/notification'
